// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__P7fMf","inner":"Footer_inner__qDn1J"};